import {Calculator} from "app/model/calculator";
import {CalculatorSettings, TYPES} from "app/model/calculatorSettings";
import {forEach} from 'lodash';

export class CalculatorProvider {
    static get init() {
        return Calculator.create(window.calculator);
    }

    static update(values) {
        const calculator = CalculatorProvider.init;
        window.calculator = Object.assign(calculator, values);
    }

    static declareSettings() {
        const provider = new CalculatorProvider();
        const settings = new CalculatorSettings();
        const {type, config} = CalculatorProvider.init;
        const resolvedConfig = provider._mapConfig(config);

        if (resolvedConfig) {
            forEach(resolvedConfig, (cfg, key) => {
                settings[key] = cfg;
            })
        }

        switch (type) {
        case TYPES.disabledDirections :
            settings.disableDirections = true;
            break;
        case TYPES.permanentDeliveryMethods :
            settings.hideDeliveryMethods = true;
        }

        return settings;
    }

    /** @private */
    _mapConfig(config) {
        const obj = {};

        if (!config) {
            return;
        }

        config.map(value => obj[value] = Boolean(value));

        return obj;
    }
}
